export default __webpack_public_path__ + "static/media/pink-inner.310ac925.svg";